import {
  LoginPageActions, SetCode, SetTitle, SetErrorCounteUsername, SET_CODE, SET_TITLE, SET_ERROR_COUNTER, SET_ERROR_COUNTER_USERNAME, RESET_ERROR_COUNTER,
} from './LoginPage.actions';
import LoginPageState from './interfaces/LoginPageState';

const formPageReducer = (state: LoginPageState, action: LoginPageActions): LoginPageState => {
  switch (action.type) {
    case SET_TITLE:
      return setTitle(state, action);
    case SET_CODE:
      return setCode(state, action);
    case SET_ERROR_COUNTER:
      return setErrorCounter(state);
    case RESET_ERROR_COUNTER:
      return resetErrorCounter(state);
    case SET_ERROR_COUNTER_USERNAME:
      return setErrorCounterUsername(state, action);
    default:
      return state;
  }
};

const setTitle = (state: LoginPageState, action: SetTitle): LoginPageState => ({
  ...state,
  title: action.title,
});

const setCode = (state: LoginPageState, action: SetCode): LoginPageState => ({
  ...state,
  code: action.code,
});

const setErrorCounter = (state: LoginPageState): LoginPageState => ({
  ...state,
  errorCounter: state.errorCounter + 1,
});

const resetErrorCounter = (state: LoginPageState): LoginPageState => ({
  ...state,
  errorCounter: 0,
});

const setErrorCounterUsername = (state: LoginPageState, action: SetErrorCounteUsername): LoginPageState => ({
  ...state,
  username: action.username,
});

export default formPageReducer;
